import { defineMessages } from 'react-intl';

export default defineMessages({
  documentCurrentrevision: {
    id: 'app.common.modules.privacyPolicy.text.documentCurrentrevision',
    defaultMessage: 'Document current revision as of February 15, 2024, 11:59 am MST',
  },
  peakPaymentsPrivacyPolicyoutlines: {
    id: 'app.common.modules.privacyPolicy.text.peakPaymentsPrivacyPolicyoutlines',
    defaultMessage: `Peak Payment's Privacy Policy outlines how we collect, use, and protect your information. By using our services via your health or wellness facility, you consent to the practices described in this policy.`,
  },
  informationWeCollect: {
    id: 'app.common.modules.privacyPolicy.title.informationWeCollect',
    defaultMessage: 'Information We Collect',
  },
  personalInformation: {
    id: 'app.common.modules.privacyPolicy.text.personalInformation',
    defaultMessage:
      'Personal Information: When you sign up or use our services, we may collect certain personal information, including but not limited to your name, email address, and other contact information.',
  },
  referralProgramWeOfferAnOptional: {
    id: 'app.common.modules.privacyPolicy.text.referralProgramWeOfferAnOptional',
    defaultMessage:
      'Referral Program: We offer an optional referral program that allows you to participate and refer contacts to our services. If you choose to participate in the referral program, you may provide us with the contact information (such as names, phone numbers, and email addresses) of individuals whom you wish to refer to our services.',
  },
  profileImage: {
    id: 'app.common.modules.privacyPolicy.text.profileImage',
    defaultMessage:
      'Profile Image: If you choose to upload a profile image, we collect and store this visual representation of yourself on our servers. This image may be used to personalise your account and enhance the community aspect of our platform. Please be aware that any profile image you upload is subject to our content policies. We reserve the right to review and moderate profile images to ensure they comply with our terms and service.',
  },
  howWeUseYourInformation: {
    id: 'app.common.modules.privacyPolicy.title.howWeUseYourInformation',
    defaultMessage: 'How We Use Your Information',
  },
  generalUse: {
    id: 'app.common.modules.privacyPolicy.text.generalUse',
    defaultMessage:
      'General Use: We may use your personal information to operate, maintain, and improve our services. This includes providing customer support, responding to inquiries, and sending important service-related communications.',
  },
  referralProgramIfYouDecideToParticipate: {
    id: 'app.common.modules.privacyPolicy.text.referralProgramIfYouDecideToParticipate',
    defaultMessage:
      'Referral Program: If you decide to participate in the referral program, we will use the contact information provided by you solely for the purpose of the referral program. If you submit any personal information relating to other people to us or to our service providers in connection with the service, you represent that you have the authority to do so and to permit us to use the information in accordance with this Privacy Policy. Please also note that when using the SMS feature charges from your carrier may apply.',
  },
  yourChoices: {
    id: 'app.common.modules.privacyPolicy.title.yourChoices',
    defaultMessage: 'Your Choices',
  },
  participationInReferralProgram: {
    id: 'app.common.modules.privacyPolicy.text.participationInReferralProgram',
    defaultMessage:
      'Participation in Referral Program: Participation in our referral program is entirely optional. You can choose not to participate in the program and, in turn, your contact information will not be used for referral invitations.',
  },
  updatingYourInformation: {
    id: 'app.common.modules.privacyPolicy.text.updatingYourInformation',
    defaultMessage:
      'Updating Your Information: You have the right to review, update, or delete your personal information at any time. If you wish to do so, please contact us at',
  },
  dataSecurity: {
    id: 'app.common.modules.privacyPolicy.title.dataSecurity',
    defaultMessage: 'Data Security',
  },
  weTakeDataSecuritySeriously: {
    id: 'app.common.modules.privacyPolicy.text.weTakeDataSecuritySeriously',
    defaultMessage:
      'We take data security seriously and have implemented industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.',
  },
  updatesToThisPrivacyPolicy: {
    id: 'app.common.modules.privacyPolicy.title.updatesToThisPrivacyPolicy',
    defaultMessage: 'Updates to this Privacy Policy',
  },
  weMayUpdateThisPrivacyPolicy: {
    id: 'app.common.modules.privacyPolicy.text.weMayUpdateThisPrivacyPolicy',
    defaultMessage:
      'We may update this Privacy Policy from time to time. The revised policy will be effective immediately upon posting on our website. We encourage you to review this page regularly to stay informed about our data practices.',
  },
  contactUs: {
    id: 'app.common.modules.privacyPolicy.title.contactUs',
    defaultMessage: 'Contact Us',
  },
  ifYouHaveAnyQuestions: {
    id: 'app.common.modules.privacyPolicy.text.ifYouHaveAnyQuestions',
    defaultMessage:
      'If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at',
  },
  byUsingOurServices: {
    id: 'app.common.modules.privacyPolicy.text.byUsingOurServices',
    defaultMessage:
      'By using our services, you acknowledge that you have read and understood this Privacy Policy, and you agree to the collection and use of your information as described herein.',
  },
  cookiesHowWeUseThem: {
    id: 'app.common.modules.privacyPolicy.title.cookiesHowWeUseThem',
    defaultMessage: 'Cookies & How We Use Them',
  },
  whatAreCookies: {
    id: 'app.common.modules.cookiePolicy.title.whatAreCookies',
    defaultMessage: 'What Are Cookies?',
  },
  anHTTPcookie: {
    id: 'app.common.modules.cookiePolicy.text.anHTTPcookie',
    defaultMessage: `An HTTP cookie (also called web cookie, Internet cookie, browser cookie or simply cookie) is a small piece of data sent from a website and stored on the user's computer by the user's web browser while the user is browsing. Cookies were designed to be a reliable mechanism for websites to remember stateful information (such as items added in the shopping cart in an online store) or to record the user's browsing activity (including clicking particular buttons, logging in, or recording which pages were visited in the past). They can also be used to remember arbitrary pieces of information that the user previously entered into form fields such as names, addresses, passwords, and credit card numbers.`,
  },
  howWeUseCookies: {
    id: 'app.common.modules.cookiePolicy.title.howWeUseCookies',
    defaultMessage: 'How We Use Cookies',
  },
  weUseCookies: {
    id: 'app.common.modules.cookiePolicy.text.weUseCookies',
    defaultMessage:
      'We use cookies to temporarily store assets from the website on your computers hard-drive. We do this to increase the performance, page load times, and the overall experience of our website.',
  },
  byUsingThisWebsit: {
    id: 'app.common.modules.cookiePolicy.text.byUsingThisWebsit',
    defaultMessage: 'By using this website',
  },
  youAgreeToOurCookiePolicy: {
    id: 'app.common.modules.cookiePolicy.text.youAgreeToOurCookiePolicy',
    defaultMessage: 'you agree to our cookie policy',
  },
  soWhatDoWeStore: {
    id: 'app.common.modules.cookiePolicy.text.soWhatDoWeStore',
    defaultMessage: 'So, what do we store?',
  },
  imagesFontsAndIconGlyphs: {
    id: 'app.common.modules.cookiePolicy.text.imagesFontsAndIconGlyphs',
    defaultMessage: 'Images, fonts, and icon glyphs',
  },
  anonymousAnalyticsData: {
    id: 'app.common.modules.cookiePolicy.text.anonymousAnalyticsData',
    defaultMessage: 'Anonymous analytics data',
  },
  geoAnalyticsData: {
    id: 'app.common.modules.cookiePolicy.text.geoAnalyticsData',
    defaultMessage: 'GeoAnalytics data (for collecting data on where our viewers are from)',
  },
  andThatsIt: {
    id: 'app.common.modules.cookiePolicy.text.andThatsIt',
    defaultMessage: `And that's it. We don't use targeted ads, no GeoTargetting ad data, and no third-party cookies.`,
  },
  weUnderstandYourRightToPrivacy: {
    id: 'app.common.modules.cookiePolicy.text.weUnderstandYourRightToPrivacy',
    defaultMessage:
      'We understand your right to privacy thus we work to store the absolute minimum of data required to ensure your site viewing experience is as simple, fast, and secure as possible.',
  },
  lastUpdated: {
    id: 'app.common.modules.termsOfService .text.lastUpdated',
    defaultMessage: 'Last Updated: March 3, 2025',
  },
  welcomeToPeakPayment: {
    id: 'app.common.modules.termsOfService.text.welcomeToPeakPayment',
    defaultMessage:
      'Welcome to PeakPayment.com (the "Website"), operated by Peak Payment Solutions ("we," "us," or "our"). These Terms of Service ("Terms") govern your access to and use of the Website, including any content, features, and services offered through the Website. By accessing or using the Website, you agree to be bound by these Terms. If you disagree with any part of the Terms, then you may not access the Website.',
  },
  useOfTheWebsite: {
    id: 'app.common.modules.termsOfService.title.useOfTheWebsite',
    defaultMessage: '1. Use of the Website',
  },
  eligibility: {
    id: 'app.common.modules.termsOfService.text.eligibility',
    defaultMessage: '1.1 Eligibility:',
  },
  youMustBeAnEmployeeOrMemberOfAGym: {
    id: 'app.common.modules.termsOfService.text.youMustBeAnEmployeeOrMemberOfAGym',
    defaultMessage:
      'You must be an employee or member of a gym that utilizes Peak Payment Solutions for its membership management and payment processing. By using the Website, you represent and warrant that you meet this eligibility requirement. If you do not meet this requirement, you must not access or use the Website.',
  },
  accountCreation: {
    id: 'app.common.modules.termsOfService.text.accountCreation',
    defaultMessage: '1.2 Account Creation: ',
  },
  youMayBeRequiredToCreateAnAccount: {
    id: 'app.common.modules.termsOfService.text.youMayBeRequiredToCreateAnAccount',
    defaultMessage:
      'You may be required to create an account to access certain features of the Website. You are responsible for maintaining the confidentiality of your account information, including your password, and you are fully responsible for all activities that occur under your account. You agree to immediately notify us of any unauthorized use of your account or any other breach of security.',
  },
  smsCommunications: {
    id: 'app.common.modules.termsOfService.title.smsCommunications',
    defaultMessage: '1.3 SMS Communications:',
  },
  consentAndOptOut: {
    id: 'app.common.modules.termsOfService.text.consentAndOptOut',
    defaultMessage:
      'Consent and Opt-Out: By using the Website, you consent to receive SMS messages related to your gym membership. These messages may include appointment reminders, class schedule changes, billing notifications, special offers, and other important updates. You can opt out of receiving SMS messages at any time by texting "STOP" to the phone number that the messages are sent from.',
  },
  unsubscribingAndRejoining: {
    id: 'app.common.modules.termsOfService.text.unsubscribingAndRejoining',
    defaultMessage:
      'Unsubscribing and Rejoining: Upon sending "STOP," you will receive an SMS confirmation of your unsubscribe status. To rejoin the SMS service, sign up as you did initially or send "START".',
  },
  messageFrequencyandSupport: {
    id: 'app.common.modules.termsOfService.text.messageFrequencyandSupport',
    defaultMessage:
      'Message Frequency and Support: Message frequency varies. If you experience issues with the messaging program, reply with the keyword "HELP" for assistance, or contact',
  },
  forPrivacyRelatedInquiries: {
    id: 'app.common.modules.termsOfService.text.forPrivacyRelatedInquiries',
    defaultMessage: '. For privacy-related inquiries, please refer to our privacy policy:',
  },
  carrierAndDataRates: {
    id: 'app.common.modules.termsOfService.text.carrierAndDataRates',
    defaultMessage:
      'Carrier and Data Rates: Carriers are not liable for delayed or undelivered messages. Message and data rates may apply for any messages sent or received. For questions about your text plan or data plan, please contact your wireless provider.',
  },
  permittedUse: {
    id: 'app.common.modules.termsOfService.text.permittedUse',
    defaultMessage: '1.4 Permitted Use:',
  },
  permittedUsesOfTheWebsiteInclude: {
    id: 'app.common.modules.termsOfService.text.permittedUsesOfTheWebsiteInclude',
    defaultMessage:
      'Permitted uses of the Website include membership sales, membership management, scheduling, referral program, reporting, and other features and services as provided by the Website.',
  },
  prohibitedUse: {
    id: 'app.common.modules.termsOfService.text.prohibitedUse',
    defaultMessage: '1.5 Prohibited Use:',
  },
  youMayNotUseTheWebsiteTo: {
    id: 'app.common.modules.termsOfService.text.youMayNotUseTheWebsiteTo',
    defaultMessage:
      'You may not use the Website for any illegal or unauthorized purpose. You agree to comply with all applicable laws and regulations while using the Website. You may not:',
  },
  useTheWebsiteToImpersonate: {
    id: 'app.common.modules.termsOfService.text.useTheWebsiteToImpersonate',
    defaultMessage:
      'Use the Website to impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity.',
  },
  interfereWithOrDisruptTheWebsite: {
    id: 'app.common.modules.termsOfService.text.interfereWithOrDisruptTheWebsite',
    defaultMessage:
      'Interfere with or disrupt the Website or servers or networks connected to the Website.',
  },
  useAnyDataMining: {
    id: 'app.common.modules.termsOfService.text.useAnyDataMining',
    defaultMessage: 'Use any data mining, robots, or similar data gathering or extraction methods.',
  },
  attemptToGainUnauthorizedAccess: {
    id: 'app.common.modules.termsOfService.text.attemptToGainUnauthorizedAccess',
    defaultMessage:
      'Attempt to gain unauthorized access to the Website or any accounts, computer systems, or networks connected to the Website.',
  },
  useTheWebsiteToTransmitAnyViruses: {
    id: 'app.common.modules.termsOfService.text.useTheWebsiteToTransmitAnyViruses',
    defaultMessage:
      'Use the Website to transmit any viruses, worms, defects, Trojan horses, or other items of a destructive nature.',
  },
  violateThePrivacyOfAnyThirdParty: {
    id: 'app.common.modules.termsOfService.text.violateThePrivacyOfAnyThirdParty',
    defaultMessage: 'Violate the privacy of any third party.',
  },
  useTheWebsiteToTransmit: {
    id: 'app.common.modules.termsOfService.text.useTheWebsiteToTransmit',
    defaultMessage:
      'Use the Website to transmit any unsolicited or unauthorized advertising, promotional materials, "junk mail," "spam," "chain letters," "pyramid schemes," or any other form of solicitation.',
  },
  intellectualProperty: {
    id: 'app.common.modules.termsOfService.title.intellectualProperty',
    defaultMessage: '2. Intellectual Property',
  },
  ownership: {
    id: 'app.common.modules.termsOfService.title.ownership',
    defaultMessage: '2.1 Ownership:',
  },
  theWebsiteAndItsEntireContents: {
    id: 'app.common.modules.termsOfService.title.theWebsiteAndItsEntireContents',
    defaultMessage:
      'The Website and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by us, our licensors, or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.',
  },
  limitedLicense: {
    id: 'app.common.modules.termsOfService.text.limitedLicense',
    defaultMessage: '2.2 Limited License:',
  },
  theseTermsPermitYouToUse: {
    id: 'app.common.modules.termsOfService.text.theseTermsPermitYouToUse',
    defaultMessage:
      'These Terms permit you to use the Website for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Website, except as follows:',
  },
  yourComputerMayTemporarilyStoreCopies: {
    id: 'app.common.modules.termsOfService.text.yourComputerMayTemporarilyStoreCopies',
    defaultMessage:
      'Your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials.',
  },
  youMayStoreFilesThatAreAutomaticallyCached: {
    id: 'app.common.modules.termsOfService.text.youMayStoreFilesThatAreAutomaticallyCached',
    defaultMessage:
      'You may store files that are automatically cached by your web browser for display enhancement purposes.',
  },
  youMayPrintOrDownloadOneCopyOfAReasonable: {
    id: 'app.common.modules.termsOfService.text.youMayPrintOrDownloadOneCopyOfAReasonable',
    defaultMessage:
      'You may print or download one copy of a reasonable number of pages of the Website for your own personal, non-commercial use and not for further reproduction, publication, or distribution.',
  },
  noModification: {
    id: 'app.common.modules.termsOfService.text.noModification',
    defaultMessage: '2.3 No Modification:',
  },
  youMustNotModifyCopiesOfAnyMaterials: {
    id: 'app.common.modules.termsOfService.text.youMustNotModifyCopiesOfAnyMaterials',
    defaultMessage: 'You must not modify copies of any materials from the Website.',
  },
  noCommercialUse: {
    id: 'app.common.modules.termsOfService.text.noCommercialUse',
    defaultMessage: '2.4 No Commercial Use:',
  },
  youMustNotUseAnyIllustrations: {
    id: 'app.common.modules.termsOfService.text.youMustNotUseAnyIllustrations',
    defaultMessage:
      'You must not use any illustrations, photographs, video or audio sequences, or any graphics separately from the accompanying text.',
  },
  reservationOfRights: {
    id: 'app.common.modules.termsOfService.text.reservationOfRights',
    defaultMessage: '2.5 Reservation of Rights:',
  },
  allRightsNotExpresslyGranted: {
    id: 'app.common.modules.termsOfService.text.allRightsNotExpresslyGranted',
    defaultMessage:
      '2.5 Reservation of Rights: All rights not expressly granted herein are reserved to us.',
  },
  disclaimer: {
    id: 'app.common.modules.termsOfService.title.disclaimer',
    defaultMessage: '3. Disclaimer',
  },
  theWebsiteAndAllContentAndServices: {
    id: 'app.common.modules.termsOfService.text.theWebsiteAndAllContentAndServices',
    defaultMessage:
      'THE WEBSITE AND ALL CONTENT AND SERVICES PROVIDED ON OR THROUGH THE WEBSITE ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE WEBSITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.',
  },
  limitationOfLiability: {
    id: 'app.common.modules.termsOfService.title.limitationOfLiability',
    defaultMessage: '4. Limitation of Liability',
  },
  inNoEventWillWe: {
    id: 'app.common.modules.termsOfService.text.inNoEventWillWe',
    defaultMessage:
      'IN NO EVENT WILL WE, OUR AFFILIATES, OR OUR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.',
  },
  indemnification: {
    id: 'app.common.modules.termsOfService.title.indemnification',
    defaultMessage: '5. Indemnification',
  },
  youAgreeToDefend: {
    id: 'app.common.modules.termsOfService.text.youAgreeToDefend',
    defaultMessage: `You agree to defend, indemnify, and hold harmless us, our affiliates, licensors, and service providers, and our and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the Website, including, but not limited to, your user contributions, any use of the Website's content, services, and products other than as expressly authorized in these Terms, or your use of any information obtained from the Website.`,
  },
  termination: {
    id: 'app.common.modules.termsOfService.title.termination',
    defaultMessage: '6. Termination',
  },
  weMayTerminateYourAccess: {
    id: 'app.common.modules.termsOfService.text.weMayTerminateYourAccess',
    defaultMessage:
      'We may terminate your access to all or any part of the Website at any time, with or without cause, with or without notice, effective immediately. If you wish to terminate these Terms or your account (if you have one), you may simply discontinue using the Website.',
  },
  governingLaw: {
    id: 'app.common.modules.termsOfService.title.governingLaw',
    defaultMessage: '7. Governing Law',
  },
  theseTermsAndAnyDispute: {
    id: 'app.common.modules.termsOfService.text.theseTermsAndAnyDispute',
    defaultMessage:
      'These Terms and any dispute or claim arising out of or in connection with them or their subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the laws of the State of Utah without regard to its conflict of law provisions.',
  },
  disputeResolution: {
    id: 'app.common.modules.termsOfService.title.disputeResolution',
    defaultMessage: '8. Dispute Resolution',
  },
  anyLegalSuit: {
    id: 'app.common.modules.termsOfService.text.anyLegalSuit',
    defaultMessage:
      'Any legal suit, action, or proceeding arising out of or relating to these Terms or the Website shall be instituted exclusively in the federal courts of the United States or the courts of the State of Utah in each case located in the City of St. George and County of Washington, although we retain the right to bring any suit, action, or proceeding against you for breach of these Terms in your country of residence or any other relevant country. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.',
  },
  waiverAndSeverability: {
    id: 'app.common.modules.termsOfService.title.waiverAndSeverability',
    defaultMessage: '9. Waiver and Severability',
  },
  noWaiverByUsOfAnyTermOrCondition: {
    id: 'app.common.modules.termsOfService.text.noWaiverByUsOfAnyTermOrCondition',
    defaultMessage:
      'No waiver by us of any term or condition set out in these Terms shall be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure by us to assert a right or provision under these Terms shall not constitute a waiver of such right or provision. If any provision of these Terms is held by a court or other tribunal of competent jurisdiction to be invalid, illegal, or unenforceable for any reason, such provision shall be eliminated or limited to the minimum extent such that the remaining provisions of the Terms will continue in full force and effect.',
  },
  entireAgreement: {
    id: 'app.common.modules.termsOfService.title.entireAgreement',
    defaultMessage: '10. Entire Agreement',
  },
  theseTermsConstituteTheSole: {
    id: 'app.common.modules.termsOfService.text.theseTermsConstituteTheSole',
    defaultMessage:
      'These Terms constitute the sole and entire agreement between you and us with respect to the Website and supersede all prior or contemporaneous communications and proposals, whether electronic, oral, or written, between you and us with respect to the Website.',
  },
  changesToTerms: {
    id: 'app.common.modules.termsOfService.title.changesToTerms',
    defaultMessage: '11. Changes to Terms',
  },
  weReserveTheRight: {
    id: 'app.common.modules.termsOfService.text.weReserveTheRight',
    defaultMessage:
      'We reserve the right, in our sole discretion, to change these Terms at any time. Any changes will be effective immediately upon posting the revised Terms to the Website. Your continued use of the Website following the posting of revised Terms means that you accept and agree to the changes.',
  },
  termsOfServiceContactUs: {
    id: 'app.common.modules.termsOfService.title.termsOfServiceContactUs',
    defaultMessage: '12. Contact Us',
  },
  termsOfServiceIfYouHaveAnyQuestions: {
    id: 'app.common.modules.termsOfService.text.termsOfServiceIfYouHaveAnyQuestions',
    defaultMessage: ' If you have any questions about these Terms, please contact us at',
  },
});
